<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>edit</v-icon>Modificar programación </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="px-3 py-2">
          <v-container grid-list-md style="min-width: 100%;" class="pa-0">
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha inicio"
                  @input="calculaDiferenciaDias()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_hasta"
                  label="Fecha fin"
                  @input="calculaDiferenciaDias()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  class="text-field-reducido-border"
                  v-if="form.fecha_desde && form.fecha_hasta"
                  v-model="total_dias"
                  label="Días"
                  disabled
                  outline
                  clearable
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      estado_vacacion: {},
      total_dias: 0,
      gestion: this.$route.params.gestion
    };
  },
  mounted() {
    this.$bus.$on("openDialogModificarCronograma", async item => {
      await this.verEstadoVacacion();
      this.form = item;
      // this.form.fecha_desde = this.$moment(this.form.fecha_desde, "DD/MM/YYYY");
      // this.form.fecha_desde = this.form.fecha_desde.format("YYYY-MM-DD");
      // this.form.fecha_hasta = this.$moment(this.form.fecha_hasta, "DD/MM/YYYY");
      // this.form.fecha_hasta = this.form.fecha_hasta.format("YYYY-MM-DD");
      this.calculaDiferenciaDias();
      this.dialog = true;
    });
  },

  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialogModificarCronograma");
      this.dialog = false;
    },
    async calculaDiferenciaDias() {
      try {
        let res;
        let year1 = new Date(this.form.fecha_desde).getFullYear();
        let year2 = new Date(this.form.fecha_hasta).getFullYear();
        if (
          year1 != parseInt(this.gestion) ||
          (year2 != parseInt(this.gestion) &&
            year2 != parseInt(this.gestion) + 1)
        ) {
          return;
        }

        if (this.form.fecha_desde && this.form.fecha_hasta) {
          let user = this.$storage.get("user");
          res = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select general.fn_cuenta_dias_habiles_por_persona('${this.form.fecha_desde}','${this.form.fecha_hasta}',${user.id_persona})"){
								respuesta
							}
							}
						`
          });
          let res2 =
            res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona;
          this.total_dias = res2;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async verEstadoVacacion() {
      let user = this.$storage.get("user");
      let id_persona = user.id_persona;
      try {
        this.estado_vacacion = await this.$query.select(
          "v_estado_vacacion",
          {
            id_persona: id_persona,
            gestion_hasta: this.gestion
          },
          ["id", "id_estado", "id_estado_programacion", "id_programacion"]
        );
        this.estado_vacacion = this.estado_vacacion[0];
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      let respuesta;
      let resps = [];
      let correcto = true;
      let user = this.$storage.get("user");
      let id_funcionario = user.id;
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await this.calculaDiferenciaDias();
          respuesta = await this.$service.graphql({
            query: `
							query{
                runQuery(consulta:"select vacaciones.fn_actualiza_vacacion_programada(${
                  this.form.id
                },${this.form.id_persona},'${this.form.fecha_desde}','${
              this.form.fecha_hasta
            }',${parseInt(this.total_dias)},${id_funcionario},${parseInt(
              this.estado_vacacion.id
            )})"){
                  respuesta
                }
              }
					  `
          });

          respuesta =
            respuesta.runQuery.respuesta[0].fn_actualiza_vacacion_programada;
          resps = respuesta.split("|");
          correcto = resps[0];

          if (correcto === "1") {
            this.$confirm("Modificación exitosa", () => {
              this.loading = false;
              this.close();
            });
          } else {
            this.$alert(resps[1], () => {
              this.loading = false;
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/ModificarCronograma.vue